import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';

// @mui
import { styled } from '@mui/material/styles';
import { Typography, Box, Button } from '@mui/material';

import pageTitle from "../utils/pageTitles.json";
import { BlankCard } from '../components/cards/blankCard';
import UsersListSvg from '../assets/svgs/usersList';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import { useNavigate } from 'react-router-dom';
import { checkButtonAccess } from 'src/utils/common';
import GatewaysModal from 'src/sections/sms/gateway/addGateway';
import { GatewayList } from 'src/sections/sms/gateway/gatewayList';

// home main section container.
const MainSection = styled('div')(({ theme }) => ({
    padding: "64px 20px 0px 88px",
    backgroundColor: "rgb(240, 240, 240)"/* theme.palette.background.default */,
    height: '100vh',
    overflow: 'hidden'
}));

// Show home hading and filtes
const HeadingSection = styled('div')(() => ({
    width: '100%',
    padding: "20px 0px 20px 0px",
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'row'
}));


const HeadingContentSection = styled('div')(() => ({
    display: 'flex',
    flexDirection: 'row',
    gap: '15px',
    alignItems: 'center',
    justifyContent: 'center',
}));

const DetailsListSection = styled('div')(() => ({
    width: '100%',
    height: 'calc(100vh - 155px)',//'554px',
    overflow: 'hidden',
    overflowY: "scroll",
}));

const GatewayListSection = ({ loadit ,setUpdateUserId, forceLoad }) => (
    <Box sx={{ width: '100%' }}>
        <DetailsListSection className='reportListScroll'>
            <GatewayList loadit={loadit}  setUpdateUserId={setUpdateUserId} forceLoad={forceLoad}/>
        </DetailsListSection>
    </Box>
)


const Gateways = () => {
    const navigate = useNavigate();
    const [openModal, setOpenModal] = useState(false);
    const [loadit, forceLoad] = useState(false);
    const [updateUserId, setUpdateUserId] = useState('');

    const handleClick = () => {
        setOpenModal(true);
    }
    const handleCloseModal = () => {
        setOpenModal(false);
        setUpdateUserId('');
        
    };

    useEffect(() => {
        if (updateUserId) {
            setOpenModal(true);
        }
    }, [updateUserId]);


 

    return (
        <>
            <Helmet>
                <title> {`${pageTitle?.smsGateways}`} </title>
            </Helmet>

            <MainSection>

                {/* Heading and filters */}
                <HeadingSection>
                    <HeadingContentSection>
                        <Box sx={{
                            widht: '16px',
                            height: '16px',
                            mt: "-10px",
                        }}>
                            <UsersListSvg />
                        </Box>
                        <Typography variant='h5' sx={{ color: 'grey.10', fontWeight: 600 }}>
                            Gateway
                        </Typography>
                    </HeadingContentSection>
                    {checkButtonAccess("smsGatewayPageList", "w") && <Button
                        startIcon={<PersonAddIcon />}
                        sx={{
                            backgroundColor: 'rgb(33, 43, 54)',
                            color: 'grey.100',
                            p: '0px 20px 0px 20px',
                            '&:hover': {
                                backgroundColor: 'rgb(69, 79, 91)'
                            }
                        }}
                        onClick={() => handleClick()}
                    >
                        Add Gateway
                    </Button>}
                </HeadingSection>

                <BlankCard
                    key="1"
                    sx={{
                        height: '100%',
                        width: '100%',
                        padding: '0px',
                        overflow: 'hidden',
                        // borderTopLeftRadius: '0px',
                        // borderTopRightRadius: '0px'
                    }}
                >
                    <GatewayListSection loadit={loadit} setUpdateUserId={setUpdateUserId} forceLoad={forceLoad} sx={{ maxHeight: "100%", overflow: 'hidden' }} />
                </BlankCard> 

            </MainSection>
            <GatewaysModal
            openModal={openModal}
            forceLoad={forceLoad}
            loadit={loadit}
            handleCloseModal={handleCloseModal}
            updateUserId={updateUserId}
            />
           
        </>
    )
}


export default Gateways;
